import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Button,
  Box
} from '@mui/material';
import {
  Block as BlockIcon,
  Home as HomeIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/constants';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #f7f8fc 0%, #e2e8f0 50%, #d1d8e4 100%)',
        padding: 2
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={10}
          sx={{
            padding: 4,
            borderRadius: 3,
            textAlign: 'center'
          }}
        >
          <BlockIcon
            sx={{
              fontSize: 80,
              color: 'error.main',
              mb: 2
            }}
          />
          
          <Typography variant="h4" component="h1" gutterBottom>
            Acesso Negado
          </Typography>
          
          <Typography variant="body1" color="text.secondary" paragraph>
            Você não tem permissão para acessar esta página.
          </Typography>
          
          <Typography variant="body2" color="text.secondary" paragraph>
            Entre em contato com o administrador do sistema para solicitar as permissões necessárias.
          </Typography>

          <Button
            variant="contained"
            startIcon={<HomeIcon />}
            onClick={() => navigate(ROUTES.HOME)}
            sx={{ mt: 2 }}
          >
            Voltar ao Demands
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default Unauthorized;
